import { Clock } from './types';

export class SystemClock implements Clock {
  now(): number {
    return typeof performance !== 'undefined' ? performance.now() : Date.now();
  }
}

export class SimulatedClock implements Clock {
  private currentTime: number;

  constructor(initialTimeMs = 0) {
    this.currentTime = initialTimeMs;
  }

  now(): number {
    return this.currentTime;
  }

  advance(deltaMs: number): void {
    if (deltaMs > 0) {
      this.currentTime += deltaMs;
    }
  }

  set(timeMs: number): void {
    this.currentTime = timeMs;
  }
}
